/*
  Wide tables on phones, two patterns. Standard: docs/CONTENT_DESIGN_STANDARD.md.

  1. Row = one item: tables with 4 or more columns (or 3 that overflow the
     column) read as cards. Copies each header label into data-label on the
     body cells and tags the table .tsg-tcards; the layout lives in tsg.css
     ("Table cards", under 640px), so desktop renders exactly as before.
     Runs on .rte tables (articles, pages, collection descriptions).
  2. Columns = items compared: PDP comparison tables (.tsg-comparison-table),
     the hub "Compare all setups" table (.tsg-hub-table), any table marked
     data-tsg-cards="off", and any table shaped "Feature | Model A | Model B"
     (the same test as content_design_lint.py table-compare-cards) keep the
     grid with a sticky first column and header, scroll sideways and show a
     "Swipe to compare" hint until the first scroll (tsg.css "Table compare").
     Wrapped only on phones, so desktop markup is untouched.

  The script tag carries data-tsg-cards="off" on product pages: there only
  pattern 2 runs.
*/
(function () {
  'use strict';
  var COMPARE = 'table.tsg-comparison-table, table.tsg-hub-table, table[data-tsg-cards="off"], [data-tsg-cards="off"] table';
  // Live tools own their tables; the LM PDP packages table has its own layout.
  var COMPARE_SKIP = '.tsg-compare-wrap, .tsg-software-wrap, .tsg-lm-pkgs, .tsg-tcmp-scroll';
  var SKIP = '[data-tsg-cards="off"], .tsg-compare-wrap, .tsg-software-wrap';
  // Corner cell of a table whose columns are the items: it names the row labels.
  var CORNER = /^(feature|features|spec|specs|specification|specifications|category|metric|compare)?$/i;
  var ITEM_LINK = 'a[href*="/products/"], a[href*="/collections/"]';
  var MIN_COLUMNS = 4;
  var PHONE = window.matchMedia('(max-width: 639px)');
  var script = document.currentScript;
  var cardsOn = !(script && script.getAttribute('data-tsg-cards') === 'off');

  function cells(row) {
    return Array.prototype.filter.call(row.children, function (c) {
      return c.tagName === 'TD' || c.tagName === 'TH';
    });
  }

  function span(cell) {
    return parseInt(cell.getAttribute('colspan'), 10) || 1;
  }

  function label(cell) {
    return cell.textContent.replace(/\s+/g, ' ').trim().replace(/:$/, '');
  }

  function headerRow(table) {
    var thead = table.tHead;
    if (thead) return thead.rows.length === 1 ? thead.rows[0] : null;
    var first = table.rows[0];
    if (!first) return null;
    return cells(first).every(function (c) { return c.tagName === 'TH'; }) ? first : null;
  }

  // A 3-column table that is wider than its column on a phone (a min-width
  // wrapper) would scroll sideways with no cue; it reads as cards too.
  function overflows(table) {
    if (!PHONE.matches) return false;
    var rte = table.closest('.rte');
    return !!rte && table.offsetWidth > rte.clientWidth + 1;
  }

  function init(table) {
    if (table.closest(SKIP) || table.querySelector('table')) return;
    if (table.querySelector('[rowspan]:not([rowspan="1"])')) return;
    var head = headerRow(table);
    if (!head) return;
    var labels = [];
    cells(head).forEach(function (c) {
      for (var i = 0; i < span(c); i++) labels.push(label(c));
    });
    if (labels.length < MIN_COLUMNS && !(labels.length === MIN_COLUMNS - 1 && overflows(table))) return;

    Array.prototype.forEach.call(table.rows, function (row) {
      if (row === head) {
        row.classList.add('tsg-tcards__head');
        return;
      }
      var col = 0;
      cells(row).forEach(function (c) {
        if (col > 0 && labels[col]) c.setAttribute('data-label', labels[col]);
        if (!c.textContent.trim() && !c.querySelector('img, svg, i')) c.classList.add('tsg-tcards__empty');
        col += span(c);
      });
    });
    table.classList.add('tsg-tcards');

    unwrap(table);
  }

  // Single-child wrappers (tsg-u-scroll-x, tsg-u-minw-720px, rte__table-wrapper)
  // drop their scroll and min-width on phones so the table fits the column.
  function unwrap(table) {
    for (var el = table.parentElement; el && !el.classList.contains('rte'); el = el.parentElement) {
      if (el.children.length !== 1) break;
      el.classList.add('tsg-tcards-wrap');
    }
  }

  function comparesColumns(table) {
    if (table.matches(COMPARE)) return true;
    var head = headerRow(table);
    if (!head) return false;
    var heads = cells(head);
    if (heads.length < 3) return false;
    var firstLinks = Array.prototype.some.call(table.rows, function (row) {
      return row !== head && cells(row)[0] && cells(row)[0].querySelector(ITEM_LINK);
    });
    if (firstLinks) return false;
    if (CORNER.test(label(heads[0]))) return true;
    return heads.slice(1).some(function (c) { return !!c.querySelector(ITEM_LINK); });
  }

  function compare(table) {
    if (table.closest(COMPARE_SKIP) || table.querySelector('table') || !table.parentNode) return;
    var first = table.rows[0];
    if (!first || cells(first).length < 3) return;
    if (table.closest('.rte')) unwrap(table);
    var wrap = document.createElement('div');
    wrap.className = 'tsg-tcmp-wrap';
    var hint = document.createElement('div');
    hint.className = 'tsg-tcmp-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = 'Swipe to compare<svg viewBox="0 0 20 12" width="20" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h17M13 1l5 5-5 5"/></svg>';
    var scroller = document.createElement('div');
    scroller.className = 'tsg-tcmp-scroll';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(hint);
    wrap.appendChild(scroller);
    scroller.appendChild(table);
    table.classList.add('tsg-tcmp');

    function measure() {
      wrap.classList.toggle('is-overflow', scroller.scrollWidth > scroller.clientWidth + 2);
    }
    function scrolled() {
      if (scroller.scrollLeft < 8) return;
      wrap.classList.add('is-scrolled');
      scroller.removeEventListener('scroll', scrolled);
    }
    scroller.addEventListener('scroll', scrolled, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(scroller);
    measure();
  }

  var compared = [];
  Array.prototype.forEach.call(document.querySelectorAll(COMPARE + ', .rte table'), function (table) {
    if (comparesColumns(table)) compared.push(table);
    else if (cardsOn && table.closest('.rte')) init(table);
  });

  function compareAll() {
    compared.forEach(compare);
  }

  if (PHONE.matches) {
    compareAll();
  } else if (PHONE.addEventListener) {
    PHONE.addEventListener('change', function once(e) {
      if (!e.matches) return;
      PHONE.removeEventListener('change', once);
      compareAll();
    });
  }
})();
